import React from 'react';
import SyncLoader from 'react-spinners/ClipLoader';

import { css } from '@emotion/react';

const override = css`
  display: block;
  margin: 0 auto;
`;

function Spinner(props) {
  return (
    <div className={props.className}>
      <SyncLoader loading={true} size={150} css={override} />
    </div>
  );
}

export default Spinner;
